import { Pipe, PipeTransform } from '@angular/core';
import { DemoHasAccessService } from '@client/app/modules/demodata/services/demo-has-access.service';

@Pipe({
    name: 'isUsingDemoData',
    standalone: false,
})
export class IsUsingDemoDataPipe implements PipeTransform {
    constructor (private demoHasAccessService: DemoHasAccessService) {}

    transform (val: any) {
        return this.demoHasAccessService.isUsingDemoData(val);
    }

}
